import { Service } from './http-service';
import type { PaginatedResponse } from '@/entities/pagination/paginated-response';
import type {
  AllocationsControllerFindAllData,
  AllocationsControllerFindAllMinimalData,
  AllocationsControllerGetAllocationMilageExpectationData,
  AllocationsControllerGetAllocationTransactionsData,
  CreateAllocationDto,
  MilageExpectationResponseDto,
  UpdateAllocationDto,
} from '@carvia/ros-client-types';
import type {
  Allocation,
  AllocationTransactionDto,
  MinimalAllocationDto,
} from '@/entities/allocations/allocation.entity.ts';

class AllocationsService extends Service<Allocation, CreateAllocationDto, UpdateAllocationDto> {
  async getAllMinimal(params: AllocationsControllerFindAllMinimalData['query']) {
    const res = await this.httpClient.get<PaginatedResponse<MinimalAllocationDto>>(
      this.endpoint + '/minimal',
      {
        params,
      },
    );
    return res.data;
  }

  async getAllWithQuery(params: AllocationsControllerFindAllData['query']) {
    const res = await this.httpClient.get<PaginatedResponse<Allocation>>(this.endpoint, {
      params,
    });
    return res.data;
  }

  async getAllocationTransactions(
    params: AllocationsControllerGetAllocationTransactionsData['query'],
  ) {
    const res = await this.httpClient.get<PaginatedResponse<AllocationTransactionDto>>(
      this.endpoint + '/transactions',
      {
        params,
      },
    );
    return res.data;
  }

  async getMilageExpectation(
    allocationId: string,
    params: AllocationsControllerGetAllocationMilageExpectationData['query'],
  ): Promise<MilageExpectationResponseDto> {
    const res = await this.httpClient.get<MilageExpectationResponseDto>(
      `${this.endpoint}/${allocationId}/milage-expectation`,
      { params },
    );
    return res.data;
  }
}

export const allocationsService = new AllocationsService('/allocations');
